    <template>
    <div>
        <div class="row py-2 mx-5">
            <div class="col-12 text-center alert alert-shippop-warning" v-if="isError.warningMsg">
                <img src="../../../assets/icon/info-driver.svg" alt="">  {{isError.warningMsg}}
            </div>
            <div class="col-12 text-center" v-if="isError.showFlashExample">
                <img src="../../../assets/images/LZDS-FlashExpress-DOF.jpg" height="350" alt="" v-if="isError.warningMsg">
            </div>
            <div class="col-12">
                <form @submit.prevent="validateTracking()">
                    <div class="row">
                        <div class="col-9">
                            <h6 class="heading-small text-muted">กรอกหมายเลขพัสดุ</h6>
                            <input
                                ref="searchTracking"
                                type="text"
                                class="form-control m-1"
                                :class="{'has-error':isError.errorMsg}"
                                :placeholder="isPlaceholder"
                                @change="clearError($event)"
                                v-on:keyup="clearError($event)"
                                v-model="isTracking.trackingCode"
                            />
                            </div>
                        <div class="col-3 d-flex align-items-end justify-content-center">
                            <b-button 
                                type="submit"
                                block
                                variant="primary" 
                                class="m-1"
                                :disabled="isTracking.trackingCode.length < 11 || isLoading"
                            >
                                <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                                นำเข้า
                            </b-button>
                        </div>
                        <div class="col-12 text-center text-danger" v-if="isError.errorMsg">
                            {{isError.errorMsg}}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:"scanTrackingLazadaDropoff",
    props:{
        isLoading: Boolean,
        isPlaceholder: String,
        isError: Object,
        isTracking: Object,
        courierCode: String,
        shopId: [Number, String]
    },
    data(){
        return{
            validateWeight:{
                checkWeight:{
                    status:false,
                    msg:""
                }
            },
        }
    },
    methods: {
        clearError( event ) {
            this.isError.errorMsg = false;
            if( this.isTracking.trackingCode.length > 5 ){
                this.$emit('checkTrackingRegx' , event)
            }
        },
        validateTracking(){
            if( this.isTracking.trackingCode.length < 11 || this.isLoading ){
                return false
            }

            this.$emit('checkTracking')
        },
    }
}

</script>